import React, { useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import HelpIcon from "@mui/icons-material/Help";

// Custom.
import AccountIcon from "@vocollege/components/dist/AccountIcon";
import GroupSelect from "components/GroupSelect";
import LogoWhiteSvg from "@vocollege/theme/dist/images/vocollege_white.svg";
import { useStyles } from "./styles";
import { VoAppContext } from "services/GlobalState";
import VoHelp from "@vocollege/components/dist/VoHelp";
import VoApi from "@vocollege/app/dist/modules/VoApi";

const Header: React.FC = () => {
  const classes = useStyles();
  const { state, dispatch } = useContext(VoAppContext);

  return (
    <>
      <AppBar position="fixed" classes={{ root: classes.appBar }}>
        <Toolbar>
          <div className={classes.logoWrapper}>
            <img src={LogoWhiteSvg} alt={process.env.REACT_APP_NAME} />
          </div>
          <div className={classes.grow} />
          <div className={classes.search}>
          </div>
          <div className={classes.sectionDesktop}>
            <GroupSelect className={classes.groupSelect} />
            <AccountIcon
              className={classes.menuButton}
            />
            <IconButton
              color="inherit"
              aria-label="Open help"
              className={classes.menuButton}
              onClick={() =>
                dispatch({ key: "helpOpen", values: !state.helpOpen })
              }
            >
              <HelpIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      <VoHelp
        open={state.helpOpen}
        onClose={() => dispatch({ key: "helpOpen", values: false })}
        client={VoApi.graphqlClient}
        settingName="voadminDefaultHelpBook"
        enlargeImages
      />
    </>
  );
};

export default Header;
